export default "__VITE_ASSET__DihK5cvj__"